import {useRoute} from "vue-router";
import {isNotEmpty} from "../tools/utils";
const router = useRoute();
const netmanagerData = {
    netData: [],
    timer:null
}
const state = () => ({
    netmanager: Object.assign({}, netmanagerData)
})
const getters = {
    netData: state => state.netmanager.netData,
    timer: state => state.netmanager.timer,
}
const mutations = {
    //把网络加入到堆栈
    add_net_to_manager(state, payload) {
        if(['sync_customer'].includes(payload.api)){//ERP引入不加入管理堆栈
            return
        }
        state.netmanager.netData.push({
            api: payload.api,
            template: payload.template ? payload.template : '',
            timeout: (payload.timeout && (typeof payload.timeout === 'number')) ? payload.timeout : 30,
            begin_time: Math.round(new Date() / 1000),
            routePath:payload.routePath
        })
        nlog(`++++++${payload.api}加入网络管理类`,'netData = ',state.netmanager.netData)
    },
    //移除网络
    remove_net_from_manager(state, payload) {
        state.netmanager.netData = state.netmanager.netData.filter((item) => item.api !== payload.api)
        nlog(`------${payload.api}从网络管理类移除`,'netData = ',state.netmanager.netData)
    },
    //移除全部网络
    remove_all_net_from_manager(state, payload) {
        state.netmanager.netData = []
        nlog('- - - - - -移除全部网络')
    }
}
const actions = {
    //网络发起
    net_request({ state, commit, dispatch }, payload) {
        nlog(`${payload.api} net_request`)
        if (!state.netmanager.timer) {
            nlog('检测到未启动定时器，先去创建定时器')
            dispatch('setup')
        }
        commit('add_net_to_manager', payload)
    },
    //网络取消
    net_cancle({ state, commit, dispatch }, payload) {
        commit('remove_net_from_manager', payload)
    },
    //网络成功
    net_sucess({ state, commit, dispatch }, payload) {
        nlog(`${payload.api} net_sucess`)
        commit('remove_net_from_manager', payload)
    },
    //网络失败
    net_fail({ state, commit, dispatch }, payload) {
        nlog(`${payload.api} net_fail`)
        commit('remove_net_from_manager', payload)
    },
    //网络超时
    net_timeout({ state, commit, dispatch }, payload) {
        console.log(`${payload.api} net_timeout`)
        commit('remove_net_from_manager', payload)
        //通知对应的页面，去修改loading值
        let msg = {
            data: {
                result:{
                    success: false,
                    msg: '网络超时，请稍后再试',
                }
            },
            command: payload.api
        }
        dispatch('channel/socket_msg_timeout',msg,{root: true})
        //底层处理超时的弹出框
        let res = {
            status: 400,
            data: { error_type: '', message: '网络超时，请稍后再试' },
            request: { responseURL: payload.api }
        }
        dispatch('response/set-response', res, { root: true })
    },
    //开始监测
    setup({state, dispatch, commit}) {
        //停止旧定时器
        if (state.netmanager.timer) {
            dispatch('stop')
        }
        //开启新定时器
        nlog('netmanager 开始监测')
        state.netmanager.timer = setInterval(() => {
            nlog('netmanager 定时器运行中...',state.netmanager.netData);
            for (const item of state.netmanager.netData) {
                let now = Math.round(new Date() / 1000)
                let before = item.begin_time
                if (now - before >= item.timeout ) {
                    if(isNotEmpty(item.routePath) && window.location.hash.indexOf(item.routePath) != -1){
                        dispatch('net_timeout',item)
                    }else if(!isNotEmpty(item.routePath)){
                        dispatch('net_timeout',item)
                    }
                }
            }
        }, 1000);
    },
    //停止监测
    stop({state, commit}) {
        commit('remove_all_net_from_manager')
        if (state.netmanager.timer) {
            clearInterval(state.netmanager.timer)
            state.netmanager.timer = null
        }
        nlog('netmanager 停止监测')
    }
}

function nlog(...args) {
    if (localStorage.getItem('nlog') === 'open') {
        console.log(...args);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
